window.slate = window.slate || {};
window.theme = window.theme || {};

/***************** GLOBAL *****************/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function () {
  var moneyFormat = '${{amount_no_decimals_with_comma_separator}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      if (!variant) {
        return;
      }

      if (window.updateVariantSignal != undefined) {
        window.current_variant = variant;
        window.updateVariantSignal(variant);
      }

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!this.currentVariant) {
        this.currentVariant = variant;
      }
      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      // window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();



/***************** TEMPLATES *****************/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
    $('.js-main-address-container').toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
    $('.js-main-address-container').toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    customerLoginForm: "#CustomerLoginForm",
    recoverPasswordLink: '#RecoverPassword',
    recoverPasswordForm: '#RecoverPasswordForm',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink',
    passwordSent: '#PasswordSent'
  };

  if (!$(config.recoverPasswordLink).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordLink).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }

    if (hash === '#recover_email_sent') {
      toggleRecoverEmailSent();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $(config.recoverPasswordForm).toggleClass('hide');
    $(config.customerLoginForm).toggleClass('hide');
  }

  function toggleRecoverEmailSent() {
    $(config.customerLoginForm).toggleClass('hide');
    $(config.passwordSent).toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    select2Wrapper: '.js-select2-wrapper',
    leftInStock: '[data-left-in-stock]',
    variantButtons: '.variant-button'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    $(selectors.select2Wrapper).select2({
      placeholder: window.theme.strings.selectPlaceholder,
      dropdownCssClass: 'custom-selector-dropdown-wrapper'
    });

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
  
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateLeftInStock.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateProductPrices.bind(this));
    this.$container.on('variantChange' + this.namespace, this.updateAffirm.bind(this));
    //this.$container.on('variantChange' + this.namespace, this.updateNotify.bind(this));
    this.initVariantButtons();

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }

    // trigger variant stuff on initial load
    var variant = this.variants._getVariantFromOptions();
    // var payload = {variant: {...variant}};
    // this.updateAddToCartState(payload);
    // this.updateLeftInStock(payload);

    if (variant && variant.id) {
      var payload = {variant: {...variant}};
    
      this.updateAddToCartState(payload);
      // this.updateLeftInStock(payload);
    }


    // this.updateAffirm(payload);
    //this.updateNotify(payload);

    // var variant_in_url = window.location.search;
    // if (variant_in_url != "") {
    //   var variant_url_split = variant_in_url.split("=");
    //   // Select2Selector.val(String("5"));
    //   // Select2Selector.trigger("change");
    //   // this.updateAddToCartState(payload);
    //   // this.updateLeftInStock(payload);
    //   // this.updateAffirm(payload);
    //   // this.updateNotify(payload);
    // }
  }

  Product.prototype = $.extend({}, Product.prototype, {
     // Initialize variant buttons
     initVariantButtons: function() {
      var self = this;

      $(selectors.variantButtons).on('click', function() {
        var variantId = $(this).data('variant-id');

        // Find the selected variant in the product object
        var selectedVariant = self.productSingleObject.variants.find(function(variant) {
          return variant.id == variantId;
        });

        if (selectedVariant) {
          // Trigger variantChange event with the selected variant
          var eventPayload = { variant: selectedVariant };
          self.$container.trigger({
            type: 'variantChange' + self.namespace,
            variant: selectedVariant
          });
        }
      });
    },

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      $(selectors.addToCart).attr("data-add-product-id", variant.id)
      

      if (variant && variant.id) {
        //$(selectors.addToCart, this.$container).prop("disabled", true);
        //$(selectors.priceWrapper, this.$container).removeClass('hide');

        // show variant image in gallery
        if (variant.featured_image) {
          // hide current active image, if there is one
          const img = document.querySelector(`[data-variant-image].active`)
          if (img) img.classList.remove("active");

          // show correct image
          const currentVariantImage = variant && variant.featured_image ? document.querySelector(`[data-variant-image="${variant.featured_image.id}"]`): null;
          if(currentVariantImage)
          currentVariantImage.classList.add("active");
        
          const mediaQuery = window.matchMedia("(min-width: 992px)");
          if (mediaQuery.matches) {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          } else {
            const element = document.querySelector("div.new-product-carousel");
            element.scrollIntoView({
              behavior: "smooth",
              block: "center"
            });
          }

          // slide mobile carousel to relevant image
          MagicZoom.switchTo(window.zoomThingyID, variant.featured_image.position - 1);
        } else {
          // hide active gallery image, no variant image available for currently selected variant
          const img = document.querySelector(`[data-variant-image].active`)
          if (img) img.classList.remove("active");
        }
      } else {
        // $(selectors.addToCart, this.$container).prop('disabled', true);
        // $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        //$(selectors.priceWrapper, this.$container).addClass('hide');

        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).removeAttr('disabled');
      //   $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      //   $(".product-template__add-product-message").addClass("hide");
      } else {
       // $(selectors.addToCart, this.$container).removeAttr('disabled');
      //   $(selectors.addToCart, this.$container).prop('disabled', true);
      //   $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }

      // $('.mini-cart__item').each(function() {
      //   const available = $(this).attr("data-item-id");

      //   function checkItemInCart() {
      //     if( available == variant.id ){
      //       $('[data-add-product-id="' + available + '"]').prop('disabled', true);
      //       // $(".product-template__add-product-message").removeClass("hide");
      //       return;
      //     }
      //   }

      //   checkItemInCart();
      // })
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        //$compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        //$compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    updateLeftInStock: function(evt) {

      if (!evt.variant || !evt.variant.id) {
        $(selectors.leftInStock).addClass('visually-hidden');
        return;
      }

      let id = evt.variant.id;
      let $option = $(`${selectors.originalSelectorId} option[value=${id}]`);
      let $leftInStock = $(selectors.leftInStock);
      let inventoryQuantity = $option.attr('data-inventory-quantity');
      let inventoryPolicy = $option.attr('data-inventory-policy');
      const select = $('select[name="id"]');
      let inventoryNotifyRemainingAfter = select.data('notifyRemainingAfter')

      if (!$leftInStock.length) {
        return;
      }
      if (inventoryPolicy === 'deny' && inventoryQuantity <= inventoryNotifyRemainingAfter && inventoryQuantity > 0) {
        if ( leftInStockOverride ) {
          $leftInStock.text(leftInStockOverride.replace('[qty]', inventoryQuantity));
        }
        else {
          $leftInStock.text(theme.strings.leftInStock.replace('[qty]', inventoryQuantity));
        }
        $leftInStock.removeClass('visually-hidden');
      } else {
        $leftInStock.addClass('visually-hidden');
      }
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    },

    updateAffirm: function (evt) {
      var variant = evt.variant;
      $('.affirm-as-low-as').attr('data-amount', variant.price);
      affirm.ui.refresh();
    },

    updateNotify: function (evt) {
      let id = evt.variant.id;
      let $option = $(`${selectors.originalSelectorId} option[value=${id}]`);
      let inventoryQuantity = +$option.attr('data-inventory-quantity');
      let inventoryPolicy = $option.attr('data-inventory-policy');
      let $notifyButton = $('.js-product-notify');
      let $button = $('.js-product-submit');
      let productButtonClass = 'product-template__button--sold-out';

      if (inventoryQuantity <= 0) {
        $notifyButton.removeClass('hide');
        $button.addClass(productButtonClass);
      } else {
        $notifyButton.addClass('hide');
        $button.removeClass(productButtonClass);
      }
    }
  });

  return Product;
})();

;(function($) {
  theme.ProductCard = (function () {
    var selectors = {
      addToCart: '[data-add-to-cart]',
      addToCartText: '[data-add-to-cart-text]',
      comparePrice: '[data-compare-price]',
      comparePriceText: '[data-compare-text]',
      originalSelectorId: '[data-product-select]',
      priceWrapper: '[data-price-wrapper]',
      productFeaturedImage: '[data-product-featured-image]',
      productJson: '[data-product-json]',
      productPrice: '[data-product-price]',
      productThumbs: '[data-product-single-thumbnail]',
      singleOptionSelector: '[data-single-option-selector]',
      select2Wrapper: '.js-select2-wrapper',
      leftInStock: '[data-left-in-stock]',
      variantIdInput: '#variant-id' 
    };

    function ProductCard(container) {
      this.$container = $(container);

      if (!$(selectors.productJson, this.$container).html()) {
        return;
      }

      this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

      var options = {
        $container: this.$container,
        enableHistoryState: this.$container.data('enable-history-state') || false,
        singleOptionSelector: selectors.singleOptionSelector,
        originalSelectorId: selectors.originalSelectorId,
        product: this.productSingleObject
      };

      $(selectors.select2Wrapper, this.$container).select2({
        placeholder: window.theme.strings.selectPlaceholder,
        dropdownCssClass: 'custom-selector-dropdown-wrapper'
      });

      this.settings = {};
      this.namespace = '.product-card';
      this.variants = new slate.Variants(options);
      this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

      this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
      this.$container.on('variantChange' + this.namespace, this.updateLeftInStock.bind(this));
      this.$container.on('variantChange' + this.namespace, this.updateProductPrices.bind(this));

      this.initVariantButtons();

      this.$container.on('variantChange' + this.namespace, this.updateAffirm.bind(this));
      //this.$container.on('variantChange' + this.namespace, this.updateNotify.bind(this));

      if (this.$featuredImage.length > 0) {
        this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
        slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

        this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
      }
    }

    ProductCard.prototype = $.extend({}, ProductCard.prototype, {

      // Initialize variant button selection
      initVariantButtons: function () {
        var self = this;

        // Add event listener for each variant button
        $('.variant-button').on('click', function () {
          var variantId = $(this).data('variant-id');
          
          // Find the selected variant in the product data
          var selectedVariant = self.productSingleObject.variants.find(function(variant) {
            return variant.id == variantId;
          });

          if (selectedVariant) {
            // Update the hidden variant ID input field for form submission
            $(selectors.variantIdInput).val(selectedVariant.id);
            // Manually trigger variantChange event
            self.$container.trigger({
              type: 'variantChange',
              variant: selectedVariant
            });
          }
        });
      },


      updateAddToCartState: function (evt) {
        var variant = evt.variant;
        if (variant) {
          //$(selectors.priceWrapper, this.$container).removeClass('hide');
        } else {
          // $(selectors.addToCart, this.$container).prop('disabled', true);
          $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
          //$(selectors.priceWrapper, this.$container).addClass('hide');
          return;
        }

        if (variant.available) {
          //$(selectors.addToCart, this.$container).prop('disabled', false);
          $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        } else {
          // $(selectors.addToCart, this.$container).prop('disabled', true);
          $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        }
      },

      updateProductPrices: function (evt) {
        var variant = evt.variant;
        var $comparePrice = $(selectors.comparePrice, this.$container);
        var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

        $(selectors.productPrice, this.$container)
          .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

        if (variant.compare_at_price > variant.price) {
          $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
          //$compareEls.removeClass('hide');
        } else {
          $comparePrice.html('');
          //$compareEls.addClass('hide');
        }
      },

      updateProductImage: function (evt) {
        var variant = evt.variant;
        var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

        this.$featuredImage.attr('src', sizedImgUrl);
      },

      updateLeftInStock: function (evt) {
        let id = evt.variant.id;
        let $option = $(`${selectors.originalSelectorId} option[value=${id}]`);
        let $leftInStock = $(selectors.leftInStock);
        let inventoryQuantity = $option.attr('data-inventory-quantity');
        let inventoryPolicy = $option.attr('data-inventory-policy');

        if (!$leftInStock.length) {
          return;
        }

        if (inventoryPolicy === 'deny' && inventoryQuantity < 3 && inventoryQuantity > 0) {
          $leftInStock.text(theme.strings.leftInStock.replace('{{ qty }}', inventoryQuantity));
          $leftInStock.removeClass('visually-hidden');
        } else {
          $leftInStock.addClass('visually-hidden');
        }
      },

      onUnload: function () {
        this.$container.off(this.namespace);
      },

      updateAffirm: function (evt) {
        var variant = evt.variant;
        $('.affirm-as-low-as').attr('data-amount', variant.price);
        affirm.ui.refresh();
      },

      updateNotify: function (evt) {
        let id = evt.variant.id;
        let $option = $(`${selectors.originalSelectorId} option[value=${id}]`);
        let inventoryQuantity = +$option.attr('data-inventory-quantity');
        let $notifyButton = $('.js-product-notify');
        let $button = $('.js-product-submit');
        let productButtonClass = 'product-template__button--sold-out';

        if (inventoryQuantity === 0) {
          $notifyButton.removeClass('hidden');
          $button.addClass(productButtonClass);
        } else {
          $notifyButton.addClass('hidden');
          $button.removeClass(productButtonClass);
        }
      }
    });

    return ProductCard;
  })();

  theme.ProductCards = function (container = "[data-product-card]") {
    const containers = $(container);

    if (!containers.length) {
      return;
    }

    containers.filter(function (index, element) {
      return !$(element).hasClass("product-card--initialized");
    }).each(function (index, element) {
      new theme.ProductCard(element);

      $(element).addClass("product-card--initialized");
    });
  };
})(jQuery);



/***************** BLOCKS *****************/
(function () {
  let $header = $('.js-header');

  $(window).scroll(function () {
    if ($(this).scrollTop() > 0) {
      $header.addClass('sticky-header--scrolled');
    } else {
      $header.removeClass('sticky-header--scrolled');
    }
  });
})();


(function () {
    var $mobileMenu = $('.js-mobile-menu');
    var $toggleOpen = $('.js-mobile-menu-open');
    var $toggleClose = $('.js-mobile-menu-close');
    var $wrapper = $('.js-mobile-menu-wrapper');
    
    if (!$mobileMenu.length) {
      return;
    }




    $('.js-mobile-menu-open').on('click', function (e) {
      e.preventDefault();
      $('.js-mobile-menu').addClass('mobile-menu--open');
      $('.sticky-header').addClass('mobile-menu-active');
      $('.js-mobile-menu-open').hide(); // Hide the open icon
      $('.js-mobile-menu-close').show(); // Show the close icon
      // $('.sticky-header').removeClass('sticky-header--hover');
      bodyScrollLock.disableBodyScroll($wrapper[0]);
    });

    $('.js-mobile-menu-close').on('click', function (e) {
      e.preventDefault();
      $('.js-mobile-menu').removeClass('mobile-menu--open');
      $('.sticky-header').removeClass('mobile-menu-active'); 
      $('.js-mobile-menu-open').show(); // Show the open icon
      $('.js-mobile-menu-close').hide(); // Hide the close icon
      // $('.sticky-header').addClass('sticky-header--hover');
      bodyScrollLock.clearAllBodyScrollLocks();
    });
})();


(function () {
  let $toggle = $('.js-search-overlay-open');
  let $searchOverlay = $('.js-search-overlay');
  let $searchInput = $('.js-search-overlay-input');

  if (!$searchOverlay.length) {
    return;
  }

  $toggle.on('click', function (e) {
    e.preventDefault();
    $searchOverlay.addClass('search-overlay--open');

    setTimeout(function () {
      $searchInput.focus();
    }, 400)
  });

  $searchInput.on('blur', function() {
    $searchOverlay.removeClass('search-overlay--open');
  });
})();

(function () {
  let $link = $('.js-anchor-link');
  let $header = $('.js-header');

  if (!$link.length) {
    return;
  }

  $link.on('click', function (e) {
    e.preventDefault();
    let id = $(this).attr('href');
    let $anchorElement = $(`${id}`);

    $('html, body').animate({
      scrollTop: $anchorElement.offset().top - $header.height()
    }, 800);
  });
})();

;(function() {
  let accordionContainer = $('.js-accordion-container')
  let accordionToggle = $('.js-accordion-toggle');

  if (!accordionToggle.length) {
    return;
  }
  accordionToggle.on('click', function (e) {
    e.preventDefault();
    let accordion = $(this).parents('.js-accordion');
    let accordionContent = accordion.find('.js-accordion-content');

    accordion.toggleClass('open');
    accordionContent.stop().slideToggle(400, function() {
      $(this).css('height', '');
    });
  })
}());

;(function() {
  initCollectionSlider();
  initProductsSlider();
  initTwoColumnsGallerySlider();
  initProductImagesSlider();
  initMoreFromCollection();
  initBlogBannerSlider();
  initPressRowSlider();
  initIconRowSlider();

  function initCollectionSlider() {
    let $slider = $('.js-collection-slider');
    let $prev = $('.js-collection-slider-prev');
    let $next = $('.js-collection-slider-next');

    if (!$slider.length) {
      return;
    }

    $slider.slick({
      dots: false,
      arrows: true,
      infinite: false,
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 3.2,
      slidesToScroll: 1,
      swipeToSlide: true,
      responsive: [
        {
          breakpoint: 1394,
          settings: {
            slidesToShow: 2.7
          }
        },
        {
          breakpoint: 1175,
          settings: {
            slidesToShow: 2.1
          }
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 1.7
          }
        },
        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1.2
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.1
          }
        },
        {
          breakpoint: 400,
          settings: {
            slidesToShow: 1.01
          }
        },
        {
          breakpoint: 360,
          settings: {
            slidesToShow: 1.01
          }
        }
      ]
    });
  }

  function  initProductsSlider() {
    let $slider = $('.js-products-slider');
    let $prev = $('.js-products-slider-prev');
    let $next = $('.js-products-slider-next');

    if (!$slider.length) {
      return;
    }

    $slider.slick({
      dots: false,
      arrows: true,
      infinite: false,
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 3.7,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 2.7
          }
        },
        {
          breakpoint: 520,
          settings: {
            slidesToScroll: 2,
            slidesToShow: 2
          }
        }
      ]
    });
  }

  function initTwoColumnsGallerySlider() {
    let $slider = $('.js-slider-two-column-gallery');

    if (!$slider.length) {
      return;
    }

    $slider.slick({
      dots: true,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true
    });
  }

  function  initProductImagesSlider() {
    let $slider = $('.js-product-images-slider');
    let $prev = $('.js-product-images-slider-prev');
    let $next = $('.js-product-images-slider-next');

    if (!$slider.length) {
      return;
    }

    $slider.slick({
      dots: false,
      arrows: true,
      infinite: false,
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
    });
  }

  function  initMoreFromCollection() {
    let $slider = $('.js-more-from-collection-slider');
    let $prev = $('.js-more-from-collection-slider-prev');
    let $next = $('.js-more-from-collection-slider-next');

    if (!$slider.length) {
      return;
    }

    $slider.slick({
      dots: false,
      arrows: true,
      infinite: false,
      prevArrow: $prev,
      nextArrow: $next,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 520,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }
      ]
    });
  }

  function initBlogBannerSlider() {
    let $slider = $('.js-blog-banner-slider');
    let $paginationButton = $('.js-blog-banner-slider-pagination-button');
    let $nextButton = $('.js-blog-banner-slider-next-button');
    let activeClass = 'blog-banner__slider-pagination-item--active';

    if (!$slider.length) {
      return;
    }

    $slider.slick({
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: false,
      fade: true,
      adaptiveHeight: true
    });

    $paginationButton.on('click', function () {
      let $this = $(this);
      let sliderNumber = +$this.attr('data-slider-index');

      $slider.slick('slickGoTo', sliderNumber);
    });

    $nextButton.on('click', function () {
      $slider.slick('slickNext');
    });

    $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
      $paginationButton.removeClass(activeClass);
      $(`.js-blog-banner-slider-pagination-button[data-slider-index=${nextSlide}]`).addClass(activeClass);
    });
  }

  function initPressRowSlider() {
    let $slider = $('.js-press-row-slider');
    let $sliderWrapper = $slider.closest('.js-press-row-slider-wrapper');
    let $sliderToggle = $sliderWrapper.find('.js-press-row-toggle');
    let activeClass = 'press-row__logo-toggle--active';

    if (!$slider.length) {
      return;
    }

    $slider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: false
    });

    $sliderToggle.on('click', function () {
      let $this = $(this);
      $slider.slick('slickGoTo', $this.data('index'));
      $sliderToggle.removeClass(activeClass);
      $this.addClass(activeClass);
    });

    $slider.on('afterChange', function(event, slick, currentSlide){
      $sliderToggle.removeClass(activeClass);
      $($sliderToggle[currentSlide]).addClass(activeClass);
    });
  }

  function initIconRowSlider() {
    let $slider = $('.js-icon-row-slider');

    if (!$slider.length) {
      return;
    }

    $slider.slick({
      dots: true,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true
    });
  }
}());

(function () {
  let $video = $('.js-video');

  if (!$video.length) {
    return;
  }

  let $videoWrapper = $video.closest('.js-video-wrapper');
  let $videoButton = $videoWrapper.find('.js-video-play');

  $videoButton.on('click', function (e) {
    e.preventDefault();

    $video.addClass('open');
    $video.attr('src', $video.attr('data-src'));
  });
})();

;(function() {
  const miniCartTrigger = jQuery('[data-mini-cart-trigger]');
  const miniCartActive = 'mini-cart--shown';
  const miniCartParent = jQuery('[data-mini-cart]');
  const miniCartTopSection = jQuery('.mini-cart-top-section');
  const cartIcon = jQuery('[data-cart-icon]');
  const cartCount = jQuery('[data-cart-count]');
  const cartTotal = jQuery('[data-cart-total]');
  const cartFull = jQuery('[data-full-cart-content]');
  const cartEmpty = jQuery('[data-empty-cart-content]');
  const footer = jQuery('[data-footer]');



  const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

  if (isSafari) {
    document.body.setAttribute('class', 'body-osx');
  }

  $(document).on('cart.ready', function(event, cart) {
    const cartItems = cart.items;


    // Checkbox toggle
    $(".cart-product__checkbox").on('change', function(event) {
      const productId = event.target.getAttribute("id");
      if (event.target.checked) {
        $(".cart-product__textarea-wrapper").each(function() {
          const textareaWrapperId = $(this).attr("data-textarea-wrapper-id");
          if(textareaWrapperId === productId) {
            $(this).removeClass("hide");
          }
        })
      } else if (!event.target.checked) {
        $(".cart-product__textarea-wrapper").each(function() {
          const textareaWrapperId = $(this).attr("data-textarea-wrapper-id");
          if(textareaWrapperId === productId) {
            $(this).addClass("hide");
            $('[data-gift-block-id="' + textareaWrapperId + '"]').addClass("hide");
            $('[data-textarea-id="' + textareaWrapperId + '"]').val("");
            localStorage.removeItem(textareaWrapperId);
            $('[data-count-id="' + textareaWrapperId + '"]').text(60 + " Characters left");
            cartItems.forEach((elem, index) => {
              if(productId == elem.variant_id) {
                if (elem.properties.Custom) {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "", "Custom": "Product made to order. Item may take longer to ship."});
                } else {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": ""});
                }
              }
            })
          }
        })
      }
    });

    // Update characters left
    $(".cart-product__textarea").on('input', function() {
      const maxCount = 60;
      let count = maxCount - $(this).val().length;
      $(this).prev().text(count + " Characters left");
    });

    // Submit textarea button
    $(".cart-product__btn-submit").on('click', function(e) {
      e.preventDefault();
      const currentItem = $(this).attr("data-textarea-id");
      $('[data-gift-btn-wrap-id="' + currentItem + '"]').removeClass("hide");

      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          localStorage.setItem(currentItem, $(this).val());

          if($(this).val().trim() == "") {
            $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').removeClass('hide');
            $('[data-gift-message-id="' + textareaWrapperId + '"]').text("");
            $('[data-gift-btn-wrap-id="' + textareaWrapperId + '"]').addClass("hide");
          } else {
            $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').addClass('hide');
            $('[data-gift-message-id="' + textareaWrapperId + '"]').text($(this).val());
          }
        }
      })

      $(".cart-product__gift-block").each(function() {
        const textareaWrapperId = $(this).attr("data-gift-block-id");
        if(currentItem === textareaWrapperId) {
          $(this).removeClass("hide");
          $('[data-textarea-wrapper-id="' + textareaWrapperId + '"]').addClass("hide");
        }
      })

      for(let key in localStorage) {
        if (!localStorage.hasOwnProperty(key)) {
          continue;
        }
        if (currentItem == key) {
          cartItems.forEach((elem, index) => {
            if(currentItem == elem.variant_id) {
              if (elem.properties.Custom) {
                if((localStorage.getItem(key)).trim() == "") {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "Gift wrapping without a message", "Custom": "Product made to order. Item may take longer to ship."});
                } else {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": localStorage.getItem(key), "Custom": "Product made to order. Item may take longer to ship."});
                }
              } else {
                if((localStorage.getItem(key)).trim() == "") {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "Gift wrapping without a message"});
                } else {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": localStorage.getItem(key)});
                }
              }
            }
          })
        }
      }

      $(".cart-product__gift-edit-btn").addClass("btn-loading");
      $(".cart-product__gift-delete-btn").addClass("btn-loading");
      $(".cart-product__add-message").addClass("btn-loading");
    })

    // Clear textarea button
    $(".cart-product__btn-clear").on('click', function(e) {
      e.preventDefault();
      const currentItem = $(this).attr("data-textarea-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          $(this).val("");
          localStorage.removeItem(currentItem);
          $(this).prev().text(60 + " Characters left");
        }
      })
    })

    // Clear local storage when remove item from cart
    $(".mini-cart__item-remove").on('click', function(e) {
      const currentItem = $(this).attr("data-remove-button-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          localStorage.removeItem(currentItem);
          $('[data-add-product-id="' + textareaWrapperId + '"]').prop('disabled', false);
          $(".product-template__add-product-message").addClass("hide");
        }
      })
    })

    // Update gift wrap after reloading
    $(".cart-product__textarea").each(function() {
      const textareaWrapperId = $(this).attr("data-textarea-id");

      for(let key in localStorage) {
        if (!localStorage.hasOwnProperty(key)) {
          continue;
        }
        if (textareaWrapperId == key) {
          $(this).val(localStorage.getItem(key));

          if($(this).val().trim() == "") {
            $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').removeClass('hide');
            $('[data-gift-message-id="' + textareaWrapperId + '"]').text("");
            $('[data-gift-btn-wrap-id="' + textareaWrapperId + '"]').addClass("hide");
          } else {
            $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').addClass('hide');
            $('[data-gift-message-id="' + textareaWrapperId + '"]').text($(this).val());
          }

          cartItems.forEach((elem, index) => {
            if($(this).attr("data-textarea-id") == elem.variant_id) {
              document.getElementById(elem.variant_id).checked = true;
              $('[data-gift-block-id="' + elem.variant_id + '"]').removeClass("hide");
              $('[data-textarea-wrapper-id="' + elem.variant_id + '"]').addClass("hide");
            }
          })
        }
      }
    })

    // Edit gift wrap message
    $(".cart-product__gift-edit-btn").on('click', function(e){
      e.preventDefault();
      const currentItem = $(this).attr("data-gift-edit-btn-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          $('[data-textarea-wrapper-id="' + textareaWrapperId + '"]').removeClass("hide");
          $('[data-gift-block-id="' + textareaWrapperId + '"]').addClass("hide");
        }
      })
    })

    // Delete gift wrap message
    $(".cart-product__gift-delete-btn").on('click', function(e){
      e.preventDefault();
      const currentItem = $(this).attr("data-gift-delete-btn-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').removeClass('hide');
          $('[data-gift-message-id="' + textareaWrapperId + '"]').text("");
          $('[data-gift-btn-wrap-id="' + textareaWrapperId + '"]').addClass("hide");
          $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').removeClass('hide');
          localStorage.setItem(currentItem, "");

          for(let key in localStorage) {
            if (!localStorage.hasOwnProperty(key)) {
              continue;
            }
            if (currentItem == key) {
              cartItems.forEach((elem, index) => {
                if(currentItem == elem.variant_id) {
                  if (elem.properties.Custom) {
                    CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "Gift wrapping without a message", "Custom": "Product made to order. Item may take longer to ship."});
                  } else {
                    CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "Gift wrapping without a message"});
                  }
                }
              })
            }
          }
        }
      })
    })

    setTimeout(() => {
      cartItems.forEach((elem, index) => {
        $(".js-product-submit").on('click', function(e) {
          const currentItem = $(this).attr("data-add-product-id");
    
          for(let key in localStorage) {
            if (!localStorage.hasOwnProperty(key)) {
              continue;
            }
            if(elem.variant_id != key) {
              $("input#"+elem.variant_id).prop('checked', false);
              $('[data-gift-block-id="' + elem.variant_id + '"]').addClass("hide");
              $('[data-textarea-wrapper-id="' + elem.variant_id + '"]').addClass("hide");
              $('[data-textarea-id="' + elem.variant_id + '"]').val("");
            } else {
              continue;
            }
          }
        })
        $(".mini-cart__item-remove").on('click', function(e) {
          const currentItem = $(this).attr("data-add-product-id");
    
          for(let key in localStorage) {
            if (!localStorage.hasOwnProperty(key)) {
              continue;
            }
            if(elem.variant_id != key) {
              $("input#"+elem.variant_id).prop('checked', false);
              $('[data-gift-block-id="' + elem.variant_id + '"]').addClass("hide");
              $('[data-textarea-wrapper-id="' + elem.variant_id + '"]').addClass("hide");
              $('[data-textarea-id="' + elem.variant_id + '"]').val("");
            } else {
              continue;
            }
          }
        })
      })
    }, 1000)

    // Add gift wrap message
    $(".cart-product__add-message").on('click', function(e) {
      e.preventDefault();
      const currentItem = $(this).attr("data-gift-message-btn-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          $('[data-textarea-wrapper-id="' + textareaWrapperId + '"]').removeClass("hide");
          $('[data-gift-block-id="' + textareaWrapperId + '"]').addClass("hide");
        }
      })
    })

  })

  jQuery(document).on('cart.requestComplete', function(event, cart) {
    cartCount.html(cart.item_count);
    cartTotal.html(Shopify.formatMoney(cart.items_subtotal_price));
    checkVariantLimit();

    if (!miniCartParent.hasClass(miniCartActive)) {
      miniCartParent.addClass(miniCartActive);
    }

    // Checkbox toggle
    $(".cart-product__checkbox").on('change', function(event) {
      const productId = event.target.getAttribute("id");
      if (event.target.checked) {
        $(".cart-product__textarea-wrapper").each(function() {
          const textareaWrapperId = $(this).attr("data-textarea-wrapper-id");
          if(textareaWrapperId === productId) {
            $(this).removeClass("hide")
          }
        })
      } else if (!event.target.checked) {
        $(".cart-product__textarea-wrapper").each(function() {
          const textareaWrapperId = $(this).attr("data-textarea-wrapper-id");
          if(textareaWrapperId === productId) {
            $(this).addClass("hide");
            $('[data-gift-block-id="' + textareaWrapperId + '"]').addClass("hide");
            $('[data-textarea-id="' + textareaWrapperId + '"]').val("");
            localStorage.removeItem(textareaWrapperId);
            $('[data-count-id="' + textareaWrapperId + '"]').text(60 + " Characters left");
          }
          cartItems.forEach((elem, index) => {
            if(productId == elem.variant_id) {
              if (elem.properties.Custom) {
                CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "", "Custom": "Product made to order. Item may take longer to ship."});
              } else {
                CartJS.updateItem(index + 1, elem.quantity, {"Gift message": ""});
              }
            }
          })
        })
      }
    });

    const cartItems = cart.items;

    // Update characters left
    $(".cart-product__textarea").on('input', function() {
      const maxCount = 60;
      let count = maxCount - $(this).val().length;
      $(this).prev().text(count + " Characters left");
    });

    // Submit textarea button
    $(".cart-product__btn-submit").on('click', function(e) {
      e.preventDefault();
      const currentItem = $(this).attr("data-textarea-id");
      $('[data-gift-btn-wrap-id="' + currentItem + '"]').removeClass("hide");

      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          localStorage.setItem(currentItem, $(this).val());

          if($(this).val().trim() == "") {
            $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').removeClass('hide');
            $('[data-gift-message-id="' + textareaWrapperId + '"]').text("");
            $('[data-gift-btn-wrap-id="' + textareaWrapperId + '"]').addClass("hide");
          } else {
            $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').addClass('hide');
            $('[data-gift-message-id="' + textareaWrapperId + '"]').text($(this).val());
          }
        }
      })

      $(".cart-product__gift-block").each(function() {
        const textareaWrapperId = $(this).attr("data-gift-block-id");
        if(currentItem === textareaWrapperId) {
          $(this).removeClass("hide");
          $('[data-textarea-wrapper-id="' + textareaWrapperId + '"]').addClass("hide");
        }
      })

      for(let key in localStorage) {
        if (!localStorage.hasOwnProperty(key)) {
          continue;
        }
        if (currentItem == key) {
          cartItems.forEach((elem, index) => {
            if(currentItem == elem.variant_id) {
              if (elem.properties.Custom) {
                if((localStorage.getItem(key)).trim() == "") {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "Gift wrapping without a message", "Custom": "Product made to order. Item may take longer to ship."});
                } else {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": localStorage.getItem(key), "Custom": "Product made to order. Item may take longer to ship."});
                }
              } else {
                if((localStorage.getItem(key)).trim() == "") {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "Gift wrapping without a message"});
                } else {
                  CartJS.updateItem(index + 1, elem.quantity, {"Gift message": localStorage.getItem(key)});
                }
              }
            }
          })
        }
      }

      $(".cart-product__gift-edit-btn").addClass("btn-loading");
      $(".cart-product__gift-delete-btn").addClass("btn-loading");
      $(".cart-product__add-message").addClass("btn-loading");
    })

    // Clear textarea button
    $(".cart-product__btn-clear").on('click', function(e) {
      e.preventDefault();
      const currentItem = $(this).attr("data-textarea-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          $(this).val("")
          localStorage.removeItem(currentItem);
          $(this).prev().text(60 + " Characters left");
        }
      })
    })

    // Clear local storage when remove item from cart
    $(".mini-cart__item-remove").on('click', function(e) {
      const currentItem = $(this).attr("data-remove-button-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          localStorage.removeItem(currentItem);
          $('[data-add-product-id="' + textareaWrapperId + '"]').prop('disabled', false);
          $(".product-template__add-product-message").addClass("hide");
        }
      })
    })

    // Update gift wrap after reloading
    $(".cart-product__textarea").each(function() {
      const textareaWrapperId = $(this).attr("data-textarea-id");
      $('[data-add-product-id="' + textareaWrapperId + '"]').prop('disabled', true);
      if ($(".js-product-submit").attr("disabled") && $(".js-product-submit").attr('data-add-product-id') == textareaWrapperId) {
        $(".product-template__add-product-message").removeClass("hide");
      }

      for(let key in localStorage) {
        if (!localStorage.hasOwnProperty(key)) {
          continue;
        }
        if (textareaWrapperId == key) {
          $(this).val(localStorage.getItem(key));

          if($(this).val().trim() == "") {
            $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').removeClass('hide');
            $('[data-gift-message-id="' + textareaWrapperId + '"]').text("");
            $('[data-gift-btn-wrap-id="' + textareaWrapperId + '"]').addClass("hide");
          } else {
            $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').addClass('hide');
            $('[data-gift-message-id="' + textareaWrapperId + '"]').text($(this).val());
          }

          cartItems.forEach((elem, index) => {
            if($(this).attr("data-textarea-id") == elem.variant_id) {
              document.getElementById(elem.variant_id).checked = true;
              $('[data-gift-block-id="' + elem.variant_id + '"]').removeClass("hide");
              $('[data-textarea-wrapper-id="' + elem.variant_id + '"]').addClass("hide");
            }
          })
        }
      }
    })

    setTimeout(() => {
      cartItems.forEach((elem, index) => {
        $(".js-product-submit").on('click', function(e) {
          const currentItem = $(this).attr("data-add-product-id");
    
          for(let key in localStorage) {
            if (!localStorage.hasOwnProperty(key)) {
              continue;
            }
            if(elem.variant_id != key) {
              $("input#"+elem.variant_id).prop('checked', false);
              $('[data-gift-block-id="' + elem.variant_id + '"]').addClass("hide");
              $('[data-textarea-wrapper-id="' + elem.variant_id + '"]').addClass("hide");
              $('[data-textarea-id="' + elem.variant_id + '"]').val("");
            } else {
              continue;
            }
          }
        })
        $(".mini-cart__item-remove").on('click', function(e) {
          const currentItem = $(this).attr("data-add-product-id");
    
          for(let key in localStorage) {
            if (!localStorage.hasOwnProperty(key)) {
              continue;
            }
            if(elem.variant_id != key) {
              $("input#"+elem.variant_id).prop('checked', false);
              $('[data-gift-block-id="' + elem.variant_id + '"]').addClass("hide");
              $('[data-textarea-wrapper-id="' + elem.variant_id + '"]').addClass("hide");
              $('[data-textarea-id="' + elem.variant_id + '"]').val("");
            } else {
              continue;
            }
          }
        })
      })
    }, 1000)

    // / Edit gift wrap message
    $(".cart-product__gift-edit-btn").on('click', function(e){
      e.preventDefault();
      const currentItem = $(this).attr("data-gift-edit-btn-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          $('[data-textarea-wrapper-id="' + textareaWrapperId + '"]').removeClass("hide");
          $('[data-gift-block-id="' + textareaWrapperId + '"]').addClass("hide");
        }
      })
    })

    // Delete gift wrap message
    $(".cart-product__gift-delete-btn").on('click', function(e){
      e.preventDefault();
      const currentItem = $(this).attr("data-gift-delete-btn-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').removeClass('hide');
          $('[data-gift-message-id="' + textareaWrapperId + '"]').text("");
          $('[data-gift-btn-wrap-id="' + textareaWrapperId + '"]').addClass("hide");
          $('[data-gift-message-btn-id="' + textareaWrapperId + '"]').removeClass('hide');
          localStorage.setItem(currentItem, "");
          $(this).prev().text(60 + " Characters left");

          for(let key in localStorage) {
            if (!localStorage.hasOwnProperty(key)) {
              continue;
            }
            if (currentItem == key) {
              cartItems.forEach((elem, index) => {
                if(currentItem == elem.variant_id) {
                  if (elem.properties.Custom) {
                    CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "Gift wrapping without a message", "Custom": "Product made to order. Item may take longer to ship."});
                  } else {
                    CartJS.updateItem(index + 1, elem.quantity, {"Gift message": "Gift wrapping without a message"});
                  }
                }
              })
            }
          }
        }
      })
    })

    // Add gift wrap message
    $(".cart-product__add-message").on('click', function(e) {
      e.preventDefault();
      const currentItem = $(this).attr("data-gift-message-btn-id");
      $(".cart-product__textarea").each(function() {
        const textareaWrapperId = $(this).attr("data-textarea-id");
        if(currentItem === textareaWrapperId) {
          $('[data-textarea-wrapper-id="' + textareaWrapperId + '"]').removeClass("hide");
          $('[data-gift-block-id="' + textareaWrapperId + '"]').addClass("hide");
        }
      })
    })


    if (cart.item_count === 0) {
      cartIcon.removeClass('header__menu-list-item-link--cart-active');
      cartCount.addClass('hide');
      cartFull.addClass('hide');
      cartEmpty.removeClass('hide');
      footer.addClass('hide');
      localStorage.clear();
      miniCartTopSection.css('height', 'auto');
    } else {
      cartIcon.addClass('header__menu-list-item-link--cart-active');
      cartCount.removeClass('hide');
      cartFull.removeClass('hide');
      cartEmpty.addClass('hide');
      footer.removeClass('hide');
      miniCartTopSection.css('height', '100%');
    }
  });

  jQuery(document).on('input', '[data-variant]', function() {
    var $this = jQuery(this);
    CartJS.updateItem(Number.parseInt($this.attr('data-variant')), Number.parseInt($this.val()));
  });

  function addMiniCartTrigger(e) {
    e.preventDefault();
    miniCartParent.toggleClass(miniCartActive);
    if ($('body').hasClass(miniCartActive)) {
      bodyScrollLock.disableBodyScroll($(".mini-cart__wrapper")[0]);
    } else {
      bodyScrollLock.clearAllBodyScrollLocks();
    }
  }

  //Add product.json.liquid
  function checkVariantLimit() {
    const cartItemParent = jQuery('[data-minicart-item]');

    if(cartItemParent.length < 1){return};

    cartItemParent.each(function() {
      const item = jQuery(this);
      const cartItem = item.find('[data-compare-price]');
      const cartItemPrice = item.find('[data-price]').attr('data-minicart-price');
      const cartItemFullUrl = cartItem.attr('data');
      const cartItemUrl = cartItemFullUrl.split('?')[0];
      const cartItemVariant = cartItemFullUrl.split('?')[1].split('=')[1];
      const cartItemQty = item.find('[data-item-qty]').val();
      const cartItemBtnPlus = item.find('[data-qty-number-plus]');
      const cartItemMessage = item.find('[data-limit-message]');
      const addToCart = item.find('[data-limit-message]');

      jQuery.getJSON(cartItemUrl + '.js', function(product) {
        if(product.url !== cartItemUrl){return};
        cartItem.addClass('hide');

        jQuery(product.variants).each(function() {
          if(this.id == cartItemVariant && cartItemPrice < this.compare_at_price) {
            let newPrice = Shopify.formatMoney(this.compare_at_price).slice(0, -3);
            cartItem.html(newPrice);
            cartItem.removeClass('hide');
          }

          if(this.id == cartItemVariant) {
            fetch(`${cartItemUrl}?view=json`, {
              redirect: 'follow',
              credentials: 'include'
            }).then((response) => {
              response.json().then(function(parsedJson) {

                jQuery(parsedJson.option).each(function() {
                  let variant = Number.parseInt(cartItemVariant);
                  if(this[variant]) {
                    if(this[variant] == cartItemQty) {
                      cartItemMessage.removeClass('hide');
                      cartItemBtnPlus.addClass('btn-disabled');
                    } else {
                      cartItemMessage.addClass('hide');
                      cartItemBtnPlus.removeClass('btn-disabled');
                    }
                  }
                  $(".cart-product__gift-edit-btn").removeClass("btn-loading");
                  $(".cart-product__gift-delete-btn").removeClass("btn-loading");
                  $(".cart-product__add-message").removeClass("btn-loading");
                });
              })
            });
          }
        });
      });
    });
  }

  rivets.formatters.route = function (value) {
    return value !== 'Title' && value !== 'One Size';
  }

  rivets.formatters.emptyClass = function(value) {
    return !value || value === 'One Size';
  };

  rivets.formatters.hideAfter = function(name, value) {
    return name === 'Title' && value === 'One Size';
  };

  miniCartTrigger.click(addMiniCartTrigger);
  setTimeout(checkVariantLimit, 100);
}());

;(function () {
  let $formRow = $('.general-form__row');
  // $formRow.addFocusClass({
  //   focusClass: 'input-focused',
  //   stayFocusOnFilled: true
  // });

  $formRow.each(function () {
    let $this = $(this);
    let $formInput = $this.find('.general-form__input');

    if (!!$formInput.val()) {
      $this.addClass('input-focused');
    } else {
      $this.removeClass('input-focused');
    }

    $formInput.on('keyup focus blur change input', function () {
      if (!!$(this).val()) {
        $this.addClass('input-focused');
      } else {
        $this.removeClass('input-focused');
      }
    });
  });

  document.addEventListener('cf:ready', function() {
    $('.custom-field .cf-field').addFocusClass({
      focusClass: 'input-focused',
      stayFocusOnFilled: true
    });
  });

  $('.js-select').select2({
    placeholder: window.theme.strings.selectPlaceholder,
    dropdownCssClass: 'custom-selector-dropdown-wrapper'
  });

  //hide form error when select is changed
  $('.general-form__row .js-select').on('change', function(){
    $(this).parent().removeClass('general-form__error');
  })

  let $form =  $('.js-validation');
  let $requiredInputs = $form.find('[data-required="true"]');
  let $button = $form.find('.js-validate-button');

  $form.formValidation({
    errorClass: 'general-form__error',
    addClassToParent: '.general-form__row'
  });

  let isEmpty = false;

  $button.attr('disabled', 'disabled');

  $(document).on('keyup change', $requiredInputs, function () {
    isEmpty = false;

    $requiredInputs.each(function () {
      if (!$(this).val()) {
        isEmpty = true;
      }
    });

    isEmpty ? $button.prop('disabled', true) : $button.prop('disabled', false);
  });
}());

(function () {
  let $toggle = $('.js-scroll-section');
  let $wrapper = $toggle.closest('.js-scroll-section-wrapper');
  let $header = $('.js-header');

  if (!$wrapper.length) {
    return;
  }

  $toggle.on('click', function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: $wrapper.offset().top + $wrapper.height() - $header.height()
    }, 800);
  });
})();

(function () {
  let $mobile = $('.js-magic-zoom-mobile');
  let $desktop = $('.js-magic-zoom-desktop');

  if (!$desktop.length || !$mobile.length) {
    return;
  }

  updateMagicZoomPlace();

  $(window).on('resize', function () {
    updateMagicZoomPlace();
  });

  function updateMagicZoomPlace() {
    if (window.innerWidth < 1024) {
      if ($desktop.hasClass('show')) {
        $desktop.find('.MagicToolboxContainer').detach().appendTo($mobile);
        $desktop.removeClass('show');
        $mobile.addClass('show');
      }
    } else {
      if ($mobile.hasClass('show')) {
        $mobile.find('.MagicToolboxContainer').detach().appendTo($desktop);
        $mobile.removeClass('show');
        $desktop.addClass('show');
      }
    }
  }
})();

(function () {
  var maxRepetitions = 60;
  var repetitionCount = 0;
  var isWindowStyleAppended = false;
  var gorgiasChatInterval = window.setInterval(function () {
    var _container$querySelec, _container$querySelec2, _container$querySelec3;

    var container = document.querySelector('#gorgias-chat-container');
    var chatButtonHead = container === null || container === void 0 ? void 0 : (_container$querySelec = container.querySelector('#chat-button')) === null || _container$querySelec === void 0 ? void 0 : _container$querySelec.contentWindow.document.querySelector('head');
    var chatWindowHead = container === null || container === void 0 ? void 0 : (_container$querySelec2 = container.querySelector('#chat-window')) === null || _container$querySelec2 === void 0 ? void 0 : _container$querySelec2.contentWindow.document.querySelector('head');
    var chatCampaignsHead = container === null || container === void 0 ? void 0 : (_container$querySelec3 = container.querySelector('#chat-campaigns')) === null || _container$querySelec3 === void 0 ? void 0 : _container$querySelec3.contentWindow.document.querySelector('head');

    if (chatButtonHead !== null && chatButtonHead !== void 0 && chatButtonHead.children.length && chatWindowHead !== null && chatWindowHead !== void 0 && chatWindowHead.children.length && !isWindowStyleAppended) {
      var buttonStyle = document.createElement('style');
      buttonStyle.textContent = 'button {background-color: #0C1B2A !important;}'; // the custom CSS for the chat button

      chatButtonHead.appendChild(buttonStyle);
    }

    if (chatCampaignsHead !== null && chatCampaignsHead !== void 0 && chatCampaignsHead.children.length) {
      window.clearInterval(gorgiasChatInterval); // this line breaks out of the loop - make sure it's not deleted.

      var campaignStyles = document.createElement('style');
      campaignStyles.textContent = '.whatyouwanttochange {property: value}'; // the custom CSS for the chat campaigns

      chatCampaignsHead.appendChild(campaignStyles);
    }

    if (++repetitionCount == maxRepetitions) {
      window.clearInterval(gorgiasChatInterval);
    }
  }, 100);
})();

(function () {
  let $giftButton = $('.js-gift-button');

  if (!$giftButton.length) {
    return;
  }

  const targetNode = document.getElementsByClassName('shopify-product-form')[0];

  const config = { attributes: true, childList: true, subtree: true };

  const callback = function(mutationsList, observer) {
    for(const mutation of mutationsList) {
      let giftButtonApp = mutation.addedNodes[0];
      if (mutation.type === 'childList' && giftButtonApp.matches('.GiftWizard-gift-button')) {
        let $giftButtonApp = $(giftButtonApp);
        $giftButtonApp.html($giftButton.html());
        $giftButtonApp.removeClass('hide');
        observer.disconnect();
      }
    }
  };

  const observer = new MutationObserver(callback);

  observer.observe(targetNode, config);
})();

;(function() {
  let $content = $('.js-account-content');
  let mainWrapper = $('.js-account-main');
  let link = $('.js-account-link');
  let $linkBack = $('.js-account-link-back');
  let $tabs = $('.js-account-tab');
  let $navigation = $('.js-account-navigation');

  let currentId = $(location).attr('href').split("#")[1];

  link.on('click', function (e) {
    let $currentTab = $(`#${$(this).attr('href').split("#")[1]}`);
    updateTabs($currentTab);
  });

  function updateTabs($currentTab) {
    if (!$currentTab.length) {
      return;
    }

    mainWrapper.addClass('hide');
    $tabs.addClass('hide');
    $currentTab.removeClass('hide');

    if (mainWrapper.hasClass('hide')) {
      let activeLink = $(`[href="/account#${$currentTab.attr('id')}"]`);
      $linkBack.removeClass('hide');
      $navigation.addClass('account-navigation--open-tab');
      link.removeClass('active');
      activeLink.addClass('active');
    }

    if ($currentTab.attr('id') === 'StyleSession') {
      let $slider = $('.js-style-session-slider');
      let $prev = $('.js-style-session-slider-prev');
      let $next = $('.js-style-session-slider-next');

      if (!$slider.length) {
        return;
      }

      $content.addClass('account-content--style-session');

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          dots: false,
          arrows: true,
          infinite: false,
          prevArrow: $prev,
          nextArrow: $next,
          slidesToShow: 3.7,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 2.7
              }
            },
            {
              breakpoint: 520,
              settings: {
                slidesToScroll: 2,
                slidesToShow: 2
              }
            }
          ]
        });

        $slider.on('init', theme.ProductCards("[data-product-card]"));
      }
    } else {
      $content.removeClass('account-content--style-session');
    }

    updateNavigationScroll();
  }

  function updateNavigationScroll() {
    if (!$navigation.length) {
      return;
    }

    let scrollWrapper = $('.simplebar-content-wrapper');
    let currentLink = $navigation.find('.active');
    let scrollLeft = currentLink.closest('.account-navigation__item-wrapper').position().left;

    scrollWrapper.animate({
      scrollLeft: scrollLeft
    }, 400);
  }

  if (!currentId && !!mainWrapper.length) {
    $(`[href="/account"]`).addClass('active');
  }

  let timerForSimpleBar = setInterval(function () {
    if (!$navigation.length) {
      clearInterval(timerForSimpleBar);
      return;
    }

    let scrollWrapper = $('.simplebar-content-wrapper');

    if (!!scrollWrapper.length) {
      let currentLink = $navigation.find('.active');
      let scrollLeft = currentLink.closest('.account-navigation__item-wrapper').position().left;

      scrollWrapper.animate({
        scrollLeft: scrollLeft
      }, 400);
      clearInterval(timerForSimpleBar);
    }
  }, 1000);

  if (!currentId) {
    return;
  }

  updateTabs($(`#${currentId}`));
}());

$(function () {
  let acjs = undefined;

  $(document ).ready(function() {
    try {
      acjs = $('#accordionHorizontal').accordionjs();
    }
    catch(error) {
      console.log("Error:" + error);
    }
  });

  setTimeout(() => {
    var maxHeight = Math.max.apply(null, $(".accordionjs-content").map(function () {
      return $(this).outerHeight();
    }).get());

    setTimeout(() => {
      $(".accordionjs-content").each(function() {
        $(this).outerHeight(maxHeight)
      })
      $(".accordionjs-title").each(function() {
        $(this).outerHeight(maxHeight)
      })
      $(".accordionjs-select").each(function() {
        $(this).outerHeight(maxHeight)
      })
    }, 200);
  }, 100)

  $( window ).resize(function() {
    setTimeout(() => {
      var maxHeight = Math.max.apply(null, $(".accordionjs-content").map(function () {
        return $(this).outerHeight();
      }).get());
  
      setTimeout(() => {
        $(".accordionjs-content").each(function() {
          $(this).outerHeight(maxHeight)
        })
        $(".accordionjs-title").each(function() {
          $(this).outerHeight(maxHeight)
        })
        $(".accordionjs-select").each(function() {
          $(this).outerHeight(maxHeight)
        })
      }, 200);
    }, 100)
  });

  jQuery('.js-accordion-mobile').slideAccordion({
    opener: '>.js-accordion-mobile-opener',
    slider: '>.js-accordion-mobile-content',
    animSpeed: 300
  });
});

;(function() {
  $(document).ready(function(){
    let $wrapper = $('.js-wishlist-widget-wrapper');

    if (!$wrapper.length) {
      return;
    }

    function swymCallbackFn(){
      window._swat.fetch( function(products) {
        products.forEach(function (element, index) {
          if (index >= 3) {
            return;
          }

          let productTileMarkup = `<a href="${element.du}" class="account-content__box-wishlist-product">
                    <svg width="19" height="16" class="icon icon-wishlist-filled" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.226 1.36106C13.0009 -0.449482 15.892 -0.449482 17.6669 1.36106C19.4449 3.17161 19.4449 6.11769 17.6638 7.92824L9.93348 15.8139C9.81288 15.9369 9.65519 16 9.49749 16C9.33979 16 9.18209 15.9369 9.0615 15.8139L1.33116 7.92824C-0.443721 6.11769 -0.443721 3.16846 1.33116 1.35791C3.10605 -0.452637 5.99719 -0.452637 7.77208 1.35791L9.50058 3.12114L11.226 1.36106Z" fill="#0C1B2A"/></svg>
                    <img class="account-content__box-wishlist-product-image" src="${element.iu}" alt="${element.dt}">
                    <h4 class="account-content__box-wishlist-product-title">${element.dt}</h4>
                    <p class="account-content__box-wishlist-product-price">${slate.Currency.formatMoney(element.pr * 100, theme.moneyFormat)}</p>
                  </a>`;
          $wrapper.append(productTileMarkup);
        });

        if (!products.length) {
          $wrapper.append('<p class="account-content__empty-text">There is nothing in your wishlist.</p>');
        }
      });
    }

    if(!window.SwymCallbacks){
      window.SwymCallbacks = [];
    }

    window.SwymCallbacks.push(swymCallbackFn);
  });
}());

;(function() {
  let $toggle = $('.js-account-menu-popup-toggle');
  let $popup = $('.js-account-menu-popup');
  let openClass = 'account-menu-popup--shown';
  let $mobileMenu = $('.js-mobile-menu');

  if (!$popup.length) {
    return;
  }

  $toggle.on('click', function (e) {
    e.preventDefault();

    $popup.toggleClass(openClass);
    $mobileMenu.removeClass('mobile-menu--open');

    if ($popup.hasClass(openClass)) {
      bodyScrollLock.clearAllBodyScrollLocks();
      bodyScrollLock.disableBodyScroll($popup[0]);
    } else {
      bodyScrollLock.clearAllBodyScrollLocks();
    }
  });
}());

;(function() {
  let $wrapper = $('.js-scrollable-wrapper');

  if (!$wrapper.length) {
    return;
  }

  $wrapper.each(function () {
    new SimpleBar(this);
  });
}());


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});

